module.exports = __webpack_public_path__ + "img/rihua2.10ea6685.jpg";